(ns ycweb.app.website.dlp.widgets.personalrecommendations
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cards :as cards]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]))

(rum/defc card-list-view < rum/reactive [app-atom products]
  [:div.flex-grid-group
   (map
     (fn [product]
       [:div
        {:class
         (u/bem :flex-grid-block [:t-full])}
        (cards/product-card-large app-atom product)])
     products)])

(rum/defc card-grid-view < rum/reactive
  [app-atom
   {:personal-recommendations/keys
    [products columns show-viewmore-link? custom-viewmore-link
     picture-public-id mobile?]}]
  (let [six-cols? (= columns 6)
        display-products
        (if (u/presence picture-public-id)
          (drop-last products)
          products)]

    (cond
      six-cols?
      [:div
       {:class (u/bem :flex-grid-group [:align-left :small])}
       (map
         (fn [product]
           [:div
            {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 :l-1-6])}
            (cards/product-card-default app-atom product {})])
         display-products)

       (when show-viewmore-link?
         [:div
          {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 :l-1-6])}
          (cards/more-card {:url custom-viewmore-link :text "more"})])]

      (and mobile? (= columns 3))
      [:div
       {:class (u/bem :flex-grid-group [:align-left])}
       (map
         (fn [product]
           [:div
            {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-2])}
            (cards/product-card-default app-atom product {})])
         display-products)]

      :else
      [:div
       {:class (u/bem :flex-grid-group [:align-left])}
       (map
         (fn [product]
           [:div
            {:class (u/bem :flex-grid-block [:t-1-2 (str "ml-1-" columns)])}
            (cards/product-card-default app-atom product {})])
         display-products)])))

(rum/defc personal-recommendations < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:personal-recommendations/keys
         [on-page-link-id title heading-type show-content? products
          card-view show-viewmore-link? columns custom-viewmore-link
          section-size heading-size]} properties]
    (when (and show-content? (not-empty products))
      [:div
       {:id (when (u/presence on-page-link-id) on-page-link-id)
        :class
        (str "yc-section"
          (when (u/presence section-size) (str " yc-section--" section-size))
          (when (u/presence section-size) " card-section"))}
       (when (u/presence title)
         (headings/heading title {:type (keyword (str "h" heading-type)) :size (or (keyword (u/presence heading-size)) :default)}))

       (when-not (empty? products)
         (cond
           (= card-view "list")
           (card-list-view app-atom products)

           :else
           (card-grid-view app-atom properties)))

       (when (and show-viewmore-link? (< columns 6))
         [:div.u-margin-top-16
          {:class (u/bem :flex-grid-group [:m-align-right])}
          [:div.u-min-width-240
           {:class (u/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (buttons/button-web "View more"
              {:type :button
               :href custom-viewmore-link
               :full true
               :icon :arrow-right
               :icon-placement :right})]]])])))